module.exports = require("popper.js");